var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"titles container"},[_c('div',{staticClass:"section-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"section-subtitle"},[_vm._v(_vm._s(_vm.subtitle))])])
}
var staticRenderFns = []

export { render, staticRenderFns }